<script lang="ts">
	import Button from "@components/inputs/Button.svelte";
	import ClearIcon from "@svg/ClearIcon.svelte";

	const { title = "Title", onClose } = $props<{
		title?: string;
		onClose?: () => void;
	}>();
</script>

<div class="mb-3 flex items-center justify-between">
	<h3 class="text-3xl font-bold">{title}</h3>
	<div class="ml-auto">
		<Button
			variant="btn-text"
			type="button"
			onclick={() => {
				onClose?.();
			}}
		>
			<ClearIcon />
		</Button>
	</div>
</div>
